<template>
  <section
    class="block-cars cars"
    :class="[device_platform, { scrolled: is_scrolled }]"
  >
    <div class="container">
      <!-- <div class="cars__main-filter">
        <div
          class="cars__main-filter-item"
          :class="{ active: item === cars_main_filter.active }"
          v-for="item in cars_main_filter.list"
          :key="item"
          @click="cars_main_filter.active = item"
        >
          {{ item }}
        </div>
      </div> -->

      <cars-nav
        :nav_list="nav_list"
        :can_fixed="true"
        nav_class="nav-cars"
        @change="changeFilter"
        @change-position="updateBlockSize"
      ></cars-nav>

      <div class="cars__list">
        <div
          class="model"
          v-for="(model, idx) in filtered_cars"
          :key="model.id"
          :id="model.id"
          :class="{ reverse: (idx + 1) % 2 === 0 }"
        >

          <!-- ****************************** MODEL INFO ***************************** -->
          <div class="model__info">
            <h3 class="model__name" v-html="model.full_name"></h3>
            <h5
              class="model__offers-title"
            >
              <p><span class="red-text">Дополнительные&nbsp;</span> преимущества при заказе сегодня:</p>
            </h5>
            
            <ul
              class="model__offers"
            >
              <li class="model__offer">
                <p><span>2 года</span> гарантии</p>  
              </li>
              
              <li class="model__offer">
                <p>Кредит <span>5,9%</span></p>  
              </li>

              <li 
                class="model__offer" 
                v-if="model.trade_in"
              >
                <p>Бонус по трейд-ин до <span>{{ model.trade_in | finance }} ₽</span></p>
              </li>

              <li 
                class="model__offer"
                v-if="model.winter_tires"
              >
                <p>Зимние шины в подарок</p>
              </li>

              <li 
                class="model__offer" 
                v-if="model.advantage"
              >
                <p>Выгода до <span>{{ model.advantage | finance }} ₽</span></p>
              </li>

              <li 
                class="model__offer"
                v-if="model.dop"
              >
                <p v-html="model.dop"></p>
              </li>

            </ul>

            <div class="model__leasing">
              <p><span class="red-text">Уникальные</span> преимущества на покупку Audi {{ model.name }} в лизинг</p>  
            </div>

            <!-- <div class="model__timeleft">Срок действия предложения: <span>01.11.2021 - 30.11.2021</span></div> -->
            <div class="model__btns">
              <button
                v-for="(btn, i) in model.buttons"
                :key="i"
                :class="'model__btn button button_theme_' + btn.type"
                @click="
                  getCall({ type: 'sale', form: 'cars', title: `${btn.text}` })
                "
              >
                <span v-html="btn.text"></span>
              </button>
            </div>
          </div>

          <!-- ****************************** MODEL SLIDER ***************************** -->

          <div class="model__gallery">
            <div class="swiper-container" :class="model.id + '-modelSwiper'">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="(img, index) in model.slides"
                  :key="index"
                >
                  <div class="model__img-wrapper">
                    <img
                      :data-src="getImg(model.id, img)"
                      alt=""
                      class="swiper-lazy"
                      :class="'model__img ' + model.id"
                    />
                    <div
                      class="swiper-lazy-preloader swiper-lazy-preloader"
                    ></div>
                  </div>
                </div>
              </div>
              <div
                v-if="model.slides.length > 1"
                :class="'model-pagination-' + model.id"
              ></div>
            </div>
          </div>

          <h3 class="model__name model__name_mobile" v-html="model.full_name"></h3>

        </div>
      </div>
      <!-- <button
        @click="addMobileCars"
        v-if="device_platform == 'mobile'"
        class="button cars__button button_theme_bordered_white"
        v-html="mobile_cars_text"
      ></button> -->
    </div>
  </section>
</template>

<script>
import CarsNavMobile from "./cars-nav-mobile.vue";
import CarsNav from "./cars-nav.vue";
import Tooltip from "./tooltip.vue";

import finance from "../common/finance";
import Mixin from "../common/mixin";
import CarsInfo from "../common/cars-info";

import Swiper from "swiper";

export default {
  name: "block-cars",
  mixins: [finance, Mixin],
  components: { CarsNavMobile, CarsNav, Tooltip },
  data() {
    const CARS = CarsInfo.CARS;
    return {
      cars: CARS,
      swiper: {},
      car_filter: "all",
      is_scrolled: false,
      mobile_cars: 4,
      mobile_cars_text: "Показать все модели",
      cars_main_filter: {
        active: "Все",
        list: ["Все", "A", "Q", "RS"],
      },
    };
  },
  mounted() {
    this.filtered_cars.forEach((car) => {
      this.initSwiper(car);
    });
  },
  watch: {
    device_platform() {
      const keys = Object.keys(this.swiper);
      keys.forEach((key) => {
        this.swiper[key].update();
      });
    },
  },

  computed: {
    sorted_cars_list() {
      let sorted_cars = [];
      if (this.cars_main_filter.active === "Все") {
        sorted_cars = this.cars.map((car) => {
          return {
            id: car.id,
            name: car.filter_name,
          };
        });
      }

      if (this.cars_main_filter.active === "A") {
        sorted_cars = this.cars.filter((car) => {
          if (
            car.id === "a3" ||
            car.id === "a4" ||
            car.id === "a5_sportback" ||
            car.id == "a5_coupe" ||
            car.id === "a6" ||
            car.id === "a7" ||
            car.id === "a8" ||
            car.id === "s6" ||
            car.id === "S7" ||
            car.id === "S8"
          ) {
            return {
              id: car.id,
              name: car.filter_name,
            };
          }
        });
      }

      if (this.cars_main_filter.active === "Q") {
        sorted_cars = this.cars.filter((car) => {
          if (
            car.id === "q3" ||
            car.id === "q3_sportback" ||
            car.id === "q5" ||
            car.id == "q5_sportback" ||
            car.id === "q7" ||
            car.id === "sq7" ||
            car.id === "q8" ||
            car.id === "sq8"
          ) {
            return {
              id: car.id,
              name: car.filter_name,
            };
          }
        });
      }

      // if (this.cars_main_filter.active === "e-tron") {
      //   sorted_cars = this.cars.filter((car) => {
      //     if (car.id === "e_tron" || car.id === "e-tron_Sportback") {
      //       return {
      //         id: car.id,
      //         name: car.filter_name,
      //       };
      //     }
      //   });
      // }

      if (this.cars_main_filter.active === "RS") {
        sorted_cars = this.cars.filter((car) => {
          if (
            car.id === "rs_5_coupe" ||
            car.id === "rs_5_sportback" ||
            car.id === "rs_6_avant" ||
            car.id === "rs_7_Sportback" ||
            car.id === "rs_q8"
          ) {
            return {
              id: car.id,
              name: car.filter_name,
            };
          }
        });
      }

      // .sort((a, b) => {
      //   if (a.id === "e_tron" || b.id === "e_tron") {
      //     return false;
      //   }
      //   return 0;
      // });
      sorted_cars.unshift({ id: "all", name: "Все", active: true });
      return sorted_cars;
    },

    nav_list() {
      return this.sorted_cars_list.map((car) => {
        return {
          ...car,
          active: car.id === this.car_filter,
        };
      });
    },
    filtered_cars() {
      if (this.car_filter === "all") {
        return this.device_platform !== "mobile"
          ? this.cars
          : this.cars.slice(0, this.mobile_cars);
      }
      return this.cars.filter((car) => car.id === this.car_filter);
    },
  },
  methods: {
    scrollTo(where) {
      this.$emit("scrollTo", where);
    },

    addMobileCars() {
      this.mobile_cars == this.cars.length
        ? (this.mobile_cars = 4)
        : (this.mobile_cars = this.cars.length);
      this.mobile_cars == this.cars.length
        ? (this.mobile_cars_text = "Скрыть")
        : (this.mobile_cars_text = "Показать все модели");
      this.$nextTick(() => {
        this.filtered_cars.forEach((model) => {
          this.initSwiper(model);
        });
      });
    },

    initSwiper(car) {
      this.swiper[car.id] = new Swiper(`.${car.id}-modelSwiper`, {
        lazy: true,
        loop: car.slides.length > 1,
        simulateTouch: true,
        pagination: {
          el: `.model-pagination-${car.id}`,
          clickable: true,
        },
      });
    },

    getImg(id, img) {
      if (id === "e_tron" || id === "rs_q8" || id === "S8") {
        return require(`../images/cars/${id}/${img}.png`);
      }
      return require(`../images/cars/${id}/${img}.jpg`);
    },

    changeFilter(data) {
      this.car_filter = data.id;
      this.$nextTick(() => {
        this.filtered_cars.forEach((model) => {
          this.initSwiper(model);
        });
      });

      this.$emit("changeModel", data.name);
    },
    updateBlockSize(is_fixed) {
      this.is_scrolled = is_fixed;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles/constants.scss";

.red-text {
    color: #BB0130;
}

.cars {
  padding-top: 40px;
  position: relative;

  &.scrolled {
    // padding-top: 112px;
  }

  &__list {
    margin-top: 40px;
  }

  &__button {
    margin: 0 auto;
  }

  &__main-filter {
    display: flex;
  }
  &__main-filter-item {
    width: 100%;
    max-width: 172px;
    display: block;
    padding: 26px 0;
    color: #808080;
    font-size: 16px;
    font-weight: bold;
    font-family: "AudiTypeExt", sans-serif;
    position: relative;
    text-align: center;
    border-bottom: 2px solid #b3b3b3;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
    &.active {
      color: #bb0a30;
      border-color: #bb0a30;
    }
  }
}

.model {
  display: flex;
  align-items: center;
  background-color: $gray_light;
  padding: 18px 0 18px 30px;

  &:not(:last-child) {
    margin-bottom: 50px;
  }

  &.reverse {
    flex-direction: row-reverse;
    padding: 30px 30px 30px 0;

    .model__info {
      padding-right: 0;
      padding-left: 30px;
    }
  }

  &__info {
    width: 60%;
    padding-right: 30px;
    display: flex;
    flex-direction: column;
  }

  &__name {
    font-size: 36px;
    margin-bottom: 31px;

    &_mobile {
      display: none;
    }
  }

  &__offers-title {
    font-size: 18px;
    display: flex;
    align-items: center;
    margin-bottom: 38px;

    &::before {
      content: url('../images/icons/gift.svg');
      margin-right: 20px;
    }
  }

  &__offers {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    list-style: none;
    margin-bottom: 44px;
  }

  &__offer {
    font-weight: 300;
    display: flex;
    align-items: center;
    width: 48%;
    margin-bottom: 15px;

    span {
      white-space: nowrap;
      font-size: 30px;
    }

    &::before {
      content: url('../images/icons/arrow.svg');
      margin-right: 15px;
    }
  }

  &__leasing {
    font-weight: 700;
    font-size: 18px;
    padding: 40px;
    background: #F2F2F2;
    display: flex;
    align-items: center;
    width: calc(100% + 60px);
    margin-left: -30px;

    &::before {
      content: url('../images/icons/gift+.svg');
      margin-right: 20px;
    }
  }

  &__timeleft {
    font-weight: bold;
    font-size: 13px;
    margin-top: 15px;
    & span {
      color: #bb0a30;
    }
  }

  &__btns {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 40px;
  }

  &__btn {
    width: 31%;
  }

  &__gallery {
    width: 40%;
    position: relative;
    overflow: hidden;
  }

  &__img {
    width: 100%;
    max-width: 100%;
  }

  .swiper-slide {
    height: unset;
  }
}

@media (max-width: 1000px) {
  .cars {
    padding-top: 20px;
    .container {
      padding: 0;
    }
  }

  .model {
    max-width: 500px;
    height: auto;
    margin-left: auto;
    margin-right: auto;
    flex-direction: column-reverse;
    align-items: center;
    padding: 20px;

    &:not(:last-child) {
      margin-bottom: 30px;
    }

    &.reverse {
      flex-direction: column-reverse;
      padding: 20px;

      .model__info {
        padding-left: 0;
      }
    }

    &__info {
      width: 100%;
      padding-right: 0;
      padding-top: 20px;
    }

    &__name {
      display: none;
      align-self: flex-start;

      &_mobile {
        display: block;
      }
    }

    &__leasing {
      width: calc(100% + 40px);
      margin-left: -20px;
    }

    &__gallery {
      width: 100%;
    }

    &__btns {
      flex-direction: column;
      margin-top: 30px;
    }

    &__btn {
      width: 100%;
      
      &:not(:last-child) {
        margin-bottom: 10px;
      }
    }
  }
}

@media (max-width: 800px) {
  .cars {

    &__main-filter-item {
      padding: 10px 0;
      font-size: 12px;
    }
  }

  .model {
    background: #fff;
    padding-top: 0;

    &__name {
      margin-bottom: 15px;
      font-size: 24px;
    }

    &__offers-title {
      font-size: 14px;
      margin-bottom: 30px;
    }

    &__offer {
      width: 100%;
      font-size: 14px;

      span {
        font-size: 24px;
      }

      &:not(:last-child) {
        margin-right: 15px;
      }
    }

    &__leasing {
      font-size: 14px;
      padding: 10px 20px;
    }
  }
}

sup {
  font-size: 16px;
}
</style>

<style>
.model__name span {
  color: #bb0a30;
}
</style>
